module.exports = __webpack_public_path__ + "img/title@2x.f4f1f819.png";